import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

const useConversationMessages = conversation => {
    const [firstPageMessageData, setFirstPageMessageData] = useState();

    useEffect(() => {
        if (!conversation) return;

        const updateFirstPageMessageData = async () => {
            // Limit messages here so not all loaded at once
            const newMessagData = await conversation.getMessages(30);
            setFirstPageMessageData(newMessagData);
        };

        (async () => {
            await updateFirstPageMessageData();
            conversation.on('messageAdded', updateFirstPageMessageData);
        })();

        return () => {
            conversation.off('messageAdded', updateFirstPageMessageData);
        };
    }, [conversation]);

    return { firstPageMessageData };
};

useConversationMessages.propTypes = {
    conversation: PropTypes.array,
};

export default useConversationMessages;
